import { render, staticRenderFns } from "./TableDraggable.vue?vue&type=template&id=a59c3886&scoped=true&"
import script from "./TableDraggable.vue?vue&type=script&lang=js&"
export * from "./TableDraggable.vue?vue&type=script&lang=js&"
import style0 from "./TableDraggable.vue?vue&type=style&index=0&id=a59c3886&prod&lang=scss&"
import style1 from "./TableDraggable.vue?vue&type=style&index=1&id=a59c3886&prod&scoped=true&lang=css&"
import style2 from "./TableDraggable.vue?vue&type=style&index=2&id=a59c3886&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59c3886",
  null
  
)

export default component.exports